import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import WindowPopUp from './WindowPopUp';
class Chat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }

    }

    componentDidMount() {
        window.addEventListener('beforeunload', () => {
            this.closeChat();
        });
    }

    toggleChat = () => {
        this.setState(state => ({
            ...state,
            open: !state.open,
        }));
    }

    closeChat = () => {
        this.setState({
            open: false
        })
    }

    render() {
        if (this.props.CHAT_LINK) {
            return (
                <div>
                    <Icon onClick={this.toggleChat} className="large wechat" />
                    {this.state.open && (
                        <WindowPopUp close={this.closeChat} url={this.props.CHAT_LINK} title="Chat with us" />
                    )}
                </div>
            )
        }
        return null;
    }
}
export default Chat;



// WEBPACK FOOTER //
// ./src/app/components/Chat.js